import { NavLink } from "react-router-dom";
import s from "./login.module.scss";
import { Input } from '@shared/ui/input/input';
import { Checkbox } from '@shared/ui/checkbox/checkbox';
import { Button } from '@shared/ui/button/button';
import { FormProvider } from "react-hook-form";
import { ActionsWrapper, AuthAction } from "../actions-wrapper/actions-wrapper";

export const Login = ({ handleSubmit, error, formState, methods }) => {
  const submitting = formState.isSubmitting || (formState?.isSubmitted && !error);

  return (
		<FormProvider {...methods}>
			<div className={s.wrapper}>
				<div className={s.card}>
					<h2 className={s.title}>
						Авторизация
					</h2>
					<ActionsWrapper>
						<AuthAction>
							Новый пользователь?
							<NavLink to={"/sign-up"}> Создать аккаунт</NavLink>
						</AuthAction>
					</ActionsWrapper>
					{error && (error?.localMessage ? <span className={s.error}>{error?.localMessage}</span> : <span className={s.error}>Пароль или телефон введены неверно</span>)}
					<form onSubmit={handleSubmit} className={s.form}>
						<Input
							placeholder='+7(999) 999 99-99'
							name='phone'
							className={s.input}
							title='Ваш телефон'
							mask="+9(999) 999-99-99"
							disabled={submitting}
							validation={{
									required: 'Телефон обязателен',
									pattern: {
										value: /^\+\d\(\d{3}\) \d{3}-\d{2}-\d{2}$/,
										message: 'Неверный формат телефона',
									},
							}}/>
						<Input
							type="password"
							placeholder="Пароль"
							name="password"
							className={s.input}
							disabled={submitting}
							validation={{
								required: {
									value: true,
									message: "Поле незаполнено",
								},
								minLength: {
									value: 8,
									message: "Минимум 8 символов",
								},
								maxLength: {
									value: 50,
									message: "Максимум 50 символов",
								},
							}}
						/>
						<div className={s.rememberMe}>
							<Checkbox
								label="Запомнить меня"
								name="remember-me"
								className={s.checkbox}
							/>
							<NavLink to={"/forgot-password"}>Забыли пароль?</NavLink>
						</div>
						<Button
							label="Войти"
							type="submit"
							className={s.button}
							disabled={(!formState.isValid && formState.isDirty) || submitting}
							fetching={submitting}
						/>
					</form>
				</div>
			</div>
		</FormProvider>
  );
};
